import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const withdrawalApi = createAsyncThunk(
  "withdrawal",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/withdrawalList", { params });
    return response.data;
  }
);

const withdrawalSlice = createSlice({
  name: "withdrawal",
  initialState: {
    withdrawal: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(withdrawalApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(withdrawalApi.fulfilled, (state, action) => {
        state.withdrawal = action.payload;
        state.loading = false;
      })
      .addCase(withdrawalApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default withdrawalSlice.reducer;
